import Markdown from 'react-markdown';

import { DOCVIEWER_ELEMENT_TYPES, TpDocViewerElement, TpDocViewerPropertyDescription } from '../charts/interfaces';

function descriptionOrDefault(description: string | undefined | null) {
  return description || '*No description available*';
}

function limitRenderWidth(content: any, maxWidth: number): any {
  return <div style={{ maxWidth: `${maxWidth}px` }}>{content}</div>;
}

function PropertiesElement({ content }: { content: TpDocViewerPropertyDescription[] }) {
  return (
    <table>
      <thead>
        <tr>
          <td>Name</td>
          <td>Description</td>
        </tr>
      </thead>
      <tbody>
        {content.map((property) => (
          <tr key={property.name}>
            <td>
              <div>{limitRenderWidth(property.name, 200)}</div>
            </td>
            <td>{limitRenderWidth(<Markdown>{descriptionOrDefault(property.description)}</Markdown>, 800)}</td>
          </tr>
        ))}
      </tbody>
    </table>
  );
}

export function DocViewerElement({ type, id, content }: TpDocViewerElement) {
  switch (type) {
    case DOCVIEWER_ELEMENT_TYPES.STRING:
      return <Markdown>{content}</Markdown>;
    case DOCVIEWER_ELEMENT_TYPES.PROPERTY:
      return <Markdown>{`${content.name}: ${descriptionOrDefault(content.description)}`}</Markdown>;
    case DOCVIEWER_ELEMENT_TYPES.PROPERTIES:
      return <PropertiesElement content={content} />;
    default:
      return null;
  }
}
